<dokument>
  @switch (opplasting().status()) {
    @case ('venter') {
      <ng-container bakgrunn [tittel]="'Venter på opplasting'|translate"></ng-container>
    }
    @case ('lasteropp') {
      <ng-container bakgrunn [tittel]="'Laster opp'|translate">
        <mat-progress-spinner mode="determinate" [value]="opplasting().progresjon()" diameter="50"/>
      </ng-container>
    }
    @case ('avbrutt') {
      <ng-container bakgrunn [tittel]="'Avbrutt'|translate">
        <mat-icon>cancel</mat-icon>
      </ng-container>
    }
  }
    <div handling (click)="avbryt()" matTooltip="{{'Klikk for å avbryte denne opplastingen'|translate}}" data-testid="avbryt">
      @if (visAvbryt()) {
      <div class="avbryt">
        <mat-icon>cancel</mat-icon>
        <span>{{ 'Avbryt opplasting'|translate }}</span>
      </div>
      }
    </div>
  <div filnavn>
    <dokument-format-ikon [mimeinfo]="opplasting().mimeinfo" utenDokumentramme="true"/>
    <span data-testid="filnavn">{{ opplasting().fil.name }}</span>
  </div>
</dokument>
